import { BOOKING_GA_CATEGORIES, BookingPathKeys } from '../../paths';

export const REVIEW_AND_BOOK_GA_CATEGORY =
    BOOKING_GA_CATEGORIES[BookingPathKeys.reviewAndBookPath];

export const GaActionText = {
    trackClickNewSubpatient: 'New Sub-Patient Field Select',
    trackClickExitNewSubpatientModal: 'Exit Sub-Patient Modal',
    trackClickRescheduleModal: 'Closed Reschedule Modal',
    trackFinishedRescheduleModal: 'Selected Time with Reschedule Modal',
    trackViewedRescheduleModal: 'Viewed Reschedule Modal',
    trackGtmContainerLoad: 'GTM Container Successfully Loaded',
    trackClickAddPhone: 'Click Add Phone Number',
    trackClickEditPhone: 'Click Edit Phone Number',
    trackClickExitPhoneVerificationModal: 'Exit Phone Verification Modal',
};

export const PAGE_STRINGS = {
    Header: 'Review and book',
    PageTitle: 'Zocdoc | Booking | Review',
};

export const REFERRER_TYPES_EXCLUDED_FROM_REDIRECT_TO_PATIENT_HOME = [
    'directory',
    'whitelabel',
];
